"use strict";

var outFocusMenu = require("../global/outFocusMenu");
var lazyLoading = require("../global/lazyLoading");

/**
 * Updates the product tile image when hovering over a swatch color
 */
function updateProductTileSwatchImagePlp() {
    $(".js-swatch-update").hover(function () {
        var $this = $(this);
        var $productTileImageElement = $($this.closest(".product-tile").find(".tile-image"));
        var defaultTileImage = $productTileImageElement.attr("srcset");
        var swatchImageSrc = $this.data("js-product-image-source");

        $productTileImageElement.attr("srcset", swatchImageSrc);
        $this.mouseleave(function () {
            $productTileImageElement.attr("srcset", defaultTileImage);
        });
    });
}

/**
 * @function
 * @description function to reinit the Sort Order Select (without any value) on Chromium Browsers (Chrome/ Microsoft Edge/ Brave/ Opera) after clicking the "Back" button in the browser
 */
const reinitSortOrder = () => {
    const $sortOrderElement = $(".sort-order");

    if (!$sortOrderElement.val()) {
        $sortOrderElement.trigger("change");
    }
};

/**
 * @function
 * @description function to set the height of the Content Push
 */
const setContentPushHeight = () => {
    const $lastGridTile = $(".m-grid-results-product-grid > .m-grid-results-product-tile").last();
    const $productTile = $(".m-grid-results-product-grid > .m-grid-results-product-tile .c-product-tile");

    if ($productTile.length && $lastGridTile.hasClass("c-content-push")) {
        setTimeout(() => {
            const $productTileHeight = $productTile.outerHeight();

            $lastGridTile.css("height", $productTileHeight + "px");
        }, 500);
    }
};

/**
 * @function
 * @description adjust the height of the Content Push on window resize or load
 */
const adjustContentPushHeight = () => {
    $(window).on("load resize", () => {
        setContentPushHeight();
    });
};

/**
 * Updates the DOM by deleting the last product in case we are on the first page
 * and the product push is configured, also it will change the pagination link
 *
 * @return {undefined}
 */
function updatePlp() {
    var $resultsCount = $(".results-count");
    var $pagination = $(".pagination");

    //show pagination
    $pagination.removeClass("d-none");

    updateProductTileSwatchImagePlp();

    $resultsCount.removeClass("invisible--lg");
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        var $this = $(this);

        $this.removeClass("active");

        var activeDiv = $results.find("." + $this[0].className.replace(/ /g, ".").replace(/\(/g, "").replace(/\)/g, ""));

        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });

    updateDom($results, ".refinements");
}

/**
 * Update 0 results
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleNoResults($results) {
    updateDom($results, ".product-noresults");
    $(".product-noresults").removeClass("d-none");
}

function handleResultDescriptions($results) {
    updateDom($results, ".m-grid-results-description--top");
    updateDom($results, ".m-grid-results-description--bottom");

    $("body").trigger("showMore:init");
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements,
        ".product-noresults" : handleNoResults,
        ".m-grid-results-description": handleResultDescriptions
    };

    // Update DOM elements that do not require special handling
    [
        ".grid-header",
        ".header-bar",
        ".header.page-title",
        ".product-grid",
        ".content-pagination-wrapper",
        ".show-more",
        ".filter-bar",
        ".product-breadcrumb",
        ".order-section",
        ".m-grid-results-header",
        ".m-grid-results-description",
        ".refinements-sticky-wrapper"
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data("url");
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: "GET",
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));

    if ($tempDom.find(".grid-footer").length) {
        var sortOptions = $tempDom.find(".grid-footer").data("sort-options").options;
        sortOptions.forEach(function (option) {
            $("option." + option.id).val(option.url);
        });
    }
}

/**
 * Add ellipsis at the end of the select option when the text is bigger then the select width
 */

const ellipsisSelect = () => {
    let maxLength = 0;

    switch (window.mqRespond.currentViewport) {
        case "xsOnly":
            maxLength = 14;
            break;
        case "mdOnly":
            maxLength = 17;
            break;
        case "lgOnly":
            maxLength = 20;
            break;
        case "lgUp":
        case "smOnly":
            maxLength = 35;
            break;
    }

    let selectOrder = document.querySelector(".sort-order");

    if (selectOrder) {
        let selectedOption = selectOrder.options[selectOrder.selectedIndex];

        if (selectedOption) {
            let selectedOptionLength = selectedOption.text.length;
            if (selectedOptionLength > maxLength) {
                selectOrder.parentNode.classList.add("select-ellipsis");
            } else {
                selectOrder.parentNode.classList.remove("select-ellipsis");
            }
        }
    }
};

/**
 * @function
 * @description Sticky filters event. When the user scrolls up and down the filters from PLP are sticky.
 **/
const stickyFilters = () => {
    let filterBar = document.querySelector(".js-sticky-filter");

    if (filterBar) {
        let navBar = document.querySelector(".l-header");
        let stickyFilterContainer = document.querySelector(".sticky-filters-container");
        let stickyContainerDistanceTop = stickyFilterContainer.getBoundingClientRect().top;
        let navBarHeight = navBar.offsetHeight;

        if (window.mqRespond.status.lgDown && navBarHeight >= stickyContainerDistanceTop && navBar.classList.contains("fixed-top")) {
            if (filterBar.classList.contains("fixed-top")) {
                return;
            }
            filterBar.classList.add("fixed-top");
            filterBar.style.marginTop = navBarHeight + "px";
        } else {
            if (filterBar.classList.contains("fixed-top")) {
                filterBar.classList.remove("fixed-top");
                filterBar.style.marginTop = 0;
            }
        }
    }
};

// Save current search config (filters and sorting) as a state on the browser's history
function addHistoryPage(urlPartsList) {
    if (urlPartsList.length > 1) {
        var urlParam = urlPartsList[1];
        var isResetAllFilters = urlParam.includes("resetFilters");

        if (isResetAllFilters) {
            // Extract only `q` and `cgid` from the query string
            var params = new URLSearchParams(urlParam);
            var filteredParams = new URLSearchParams();

            if (params.has("q")) {
                filteredParams.set("q", params.get("q"));
            }
            if (params.has("cgid")) {
                filteredParams.set("cgid", params.get("cgid"));
            }

            urlParam = filteredParams.toString(); // q=xyz&cgid=abc
        }

        var filterURL = location.pathname + "?" + urlParam;

        history.pushState("search", document.title, filterURL);
    }

}

// construct range slider
function constructPriceRangeSlider() {
    let $priceRangeSlider = $(".refinement-price-slider");

    if ($priceRangeSlider.length === 0 ||$priceRangeSlider.hasClass("ui-slider")) {
        return;
    }

    let minPrice = $priceRangeSlider.data("min");
    let maxPrice = $priceRangeSlider.data("max");
    let selectedMinPrice = $priceRangeSlider.data("selected-min");
    let selectedMaxPrice = $priceRangeSlider.data("selected-max");

    $priceRangeSlider.slider({
        range: true,
        min: minPrice,
        max: maxPrice,
        values: [selectedMinPrice, selectedMaxPrice],
        change: handlePriceRangeChange
    });
}

// handle price range slider change
function handlePriceRangeChange(event, ui) {
    const $slider = $(event.target);
    const refinementURL = $slider.data("url");
    const paramOne = $slider.data("param-one");
    const paramTwo = $slider.data("param-two");
    const currencySymbol = encodeURI($slider.data("currency-symbol"));
    const filterParamsList = refinementURL.split("?");

    let url = "";

    if (filterParamsList.length >1) {
        url = refinementURL + "&" + paramOne + "=" + ui.values[0] + currencySymbol + "&" + paramTwo + "=" + ui.values[1] + currencySymbol;
    } else {
        url = refinementURL + "?" + paramOne + "=" + ui.values[0] + currencySymbol + "&" + paramTwo + "=" + ui.values[1] + currencySymbol;
    }

    $.ajax({
        url: url,
        data: {
            page: $(".grid-footer").data("page-number"),
            selectedUrl: url
        },
        method: "GET",
        success: function (response) {
            addHistoryPage(url.split("?"));
            parseResults(response);
            updatePlp();
            lazyLoading.refreshLazyLoadingFeature();

            $(".m-blog__filters").find("input:checked").parents("li").addClass("active-filter");
            $.spinner().stop();
            updateSortOptions(response);
            setContentPushHeight();
            constructPriceRangeSlider();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(".container").on("click", "button.filter-results", function () {
            const $refinementBar = $(".refinement-bar");
            const $checkedInputs = $(".refinement-bar .c-input--checkbox");

            $refinementBar.removeClass("d-none");
            $refinementBar.addClass("in");
            $refinementBar.siblings().attr("aria-hidden", true);
            $refinementBar.closest(".row").siblings().attr("aria-hidden", true);
            $refinementBar.closest(".tab-pane.active").siblings().attr("aria-hidden", true);
            $refinementBar.closest(".container.search-results").siblings().attr("aria-hidden", true);
            $(".refinement-bar .close").focus();
            $(".l-overlay").removeClass("d-none");
            $("body").addClass("no-scroll");

            // IOS fix for the checked inputs
            if ($checkedInputs.length) {
                $checkedInputs.each((index, element) => {
                    const $this = $(element);

                    if ($this.attr("checked")) {
                        $this.attr("checked", "checked");
                    }
                });
            }
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(".container").on("click", ".refinement-bar button.close, .modal-background", function () {
            const $refinementBar = $(".refinement-bar");
            $refinementBar.removeClass("in");
            $refinementBar.siblings().attr("aria-hidden", false);
            $refinementBar.closest(".row").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".container.search-results").siblings().attr("aria-hidden", false);
            $(".btn.filter-results").focus();
            $(".l-overlay").addClass("d-none");
            $("body").removeClass("no-scroll");
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).on("orientationchange", function () {
            const $refinementBar = $(".refinement-bar");
            $refinementBar.removeClass("in");
            $refinementBar.siblings().attr("aria-hidden", false);
            $refinementBar.closest(".row").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".container.search-results").siblings().attr("aria-hidden", false);
            $(".l-overlay").addClass("d-none");
            $("body").removeClass("no-scroll");
            ellipsisSelect();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document).on("change", "[name=sort-order]", function (e) {
            e.preventDefault();

            let filterBar = document.querySelector(".js-sticky-filter");

            $.spinner().start();
            if (filterBar && filterBar.classList.contains("fixed-top")) {
                filterBar.classList.add("sticky-prominent");
            }
            $(this).trigger("search:sort", this.value);

            var sortParamsList = this.value.split("?");

            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: "GET",
                success: function (response) {
                    let sortOrder = document.querySelector(".sort-order");

                    addHistoryPage(sortParamsList);
                    parseResults(response);
                    updatePlp();
                    lazyLoading.refreshLazyLoadingFeature();
                    ellipsisSelect();
                    outFocusMenu.init(sortOrder);
                    if (filterBar && filterBar.classList.contains("fixed-top")) {
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        if (filterBar.classList.contains("sticky-prominent")) {
                            filterBar.classList.remove("sticky-prominent");
                        }
                    }
                    constructPriceRangeSlider();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                    if (filterBar && filterBar.classList.contains("sticky-prominent")) {
                        filterBar.classList.remove("sticky-prominent");
                    }
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $(".container").on("click", ".show-more button", function (e) {
            e.stopPropagation();
            e.preventDefault();

            var $this = $(this);
            var showMoreUrl = $this.data("url");

            $.spinner().start();
            $this.trigger("search:showMore", e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: "GET",
                success: function (response) {
                    $(".grid-footer").replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(".container").on(
            "click",
            ".refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();

                var $this = $(this);
                var filterParamsList = $this.data("href").split("?");

                $this.trigger("search:filter", e);
                $.ajax({
                    url: $this.data("href"),
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: $this.data("href")
                    },
                    method: "GET",
                    success: function (response) {
                        addHistoryPage(filterParamsList);
                        parseResults(response);
                        updatePlp();
                        lazyLoading.refreshLazyLoadingFeature();

                        $(".m-blog__filters").find("input:checked").parents("li").addClass("active-filter");
                        $.spinner().stop();
                        updateSortOptions(response);
                        setContentPushHeight();
                        constructPriceRangeSlider();
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $(".container").on("click", ".content-search", function () {
            var $contentSearchResults = $("#content-search-results");

            if ($contentSearchResults.html() === "") {
                getContent($(this), $contentSearchResults);
            }
        });

        // Display the next page of content results from the search
        $(".container").on("click", ".show-more-content button", function () {
            getContent($(this), $("#content-search-results"));
            $(".show-more-content").remove();
        });
    },

    closeHamburgerOnOverlay: () => {
        // Close refinements bar when click the overlay
        $(".l-overlay").on("click", function (e) {
            e.preventDefault();

            const $refinementBar = $(".refinement-bar");
            $refinementBar.removeClass("in");
            $refinementBar.siblings().attr("aria-hidden", false);
            $refinementBar.closest(".row").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".container.search-results").siblings().attr("aria-hidden", false);
            $(".btn.filter-results").focus();
            $(".l-overlay").addClass("d-none");
            $("body").removeClass("no-scroll");
        });
    },

    updatePlp      : updatePlp,
    ellipsisSelect : ellipsisSelect,
    stickyFilters  : stickyFilters,
    reinitSortOrder: reinitSortOrder,
    adjustContentPushHeight: adjustContentPushHeight,
    constructPriceRangeSlider: constructPriceRangeSlider
};
